import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded, FuseAnimateGroup } from '@fuse';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Tab, Tabs, Grid, Typography, Table, TableHead, TableRow, TableCell, TableBody, Icon, IconButton, Divider } from '@material-ui/core';
import * as Actions from './store/actions';
import RichTextEditor from 'react-rte';
import AssetUpload from '../asset/AssetUpload';
import TabPanelButtons from '../../components/TabPanelButtons';
import * as AssetActions from '../asset/store/actions';
import * as moment from 'moment';
import _ from 'lodash';
import {parseForFrontend} from './AssignmentContentParse';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64
    },

    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
});

class StudentAssignment extends Component {
    state = {
        current_tab: 0,
        calendar_event_id: 0,
        parsedContent: '',
        parsedContentLoaded: false
    }

    constructor(props) {
        super(props);
        const calendar_event_id = this.props.match.params.calendar_event_id;
        const auth_id = this.props.auth.user.data.auth_id;

        if (this.props.auth.user.role !== "student") {
            this.props.history.push('/dashboard')
        }
        else {
            this.state = {
                ...this.state,
                calendar_event_id: calendar_event_id,
            }

            const student_id = this.props.auth.user.data.role_info.link_id
    
            this.props.updateAssignmentLoaded(false);
            this.props.getAssignmentByEventID(calendar_event_id, auth_id);
            this.props.getNextEventForContinueButton(calendar_event_id, student_id);
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        const calendar_event_id = this.props.match.params.calendar_event_id;
        const auth_id = this.props.auth.user.data.auth_id;
        if (
            !_.isEqual(calendar_event_id, prevProps.match.params.calendar_event_id)
        ) {
            this.props.updateAssignmentLoaded(false)
            this.setState({
                ...this.state,
                calendar_event_id: calendar_event_id,
                current_tab: 0,
            })
            const student_id = this.props.auth.user.data.role_info.link_id
            this.props.getAssignmentByEventID(calendar_event_id, auth_id);
            this.props.getNextEventForContinueButton(calendar_event_id, student_id);
        }
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        });
    }

    continueDisabled = () => {
        const currentAssignment = this.props.currentAssignment
        if (!this.props.nextEvent) {
            return true
        }
        if (currentAssignment.header.IsGradable === 0) {
            return false
        }
        if (currentAssignment.header.IsGradable === 1 && !this.props.studentAssignment.header.SubmissionDate) {
            return true
        }
        return false
    }

    hideContinue = () => {
        if (this.props.auth.user.role !== 'student') {
            return true
        }
        if (!this.props.nextEvent) {
            return true
        }
        return false
    }

    hideFinishCourse = () => {
        if (this.props.nextEvent || this.props.auth.user.role !== 'student') {
            return true
        }
        return false
    }

    handleContinue = () => {
        const currentAssignment = this.props.currentAssignment;
        const nextEvent = this.props.nextEvent;
        if (currentAssignment.header.IsGradable === 0 && this.props.studentAssignment.header.IsGraded === 0) {
            this.props.submitNonGradedAssignment(this.props.studentAssignment, currentAssignment.header.TotalScore)
        }
        return this.props.history.push(`/${nextEvent.EventType}/student/${nextEvent.company_calendar_event_id}`)
    }

    getGradeInfo = (props) => {
        if (props.IsGradable === 0) {
            if (props.IsGraded) {
                return <Typography variant="h6">{'Grade: ' + 'Complete'}</Typography>
            }
        }
        if (props.IsGraded) {
            return <Typography variant="h6">{'Grade: ' + Number(props.Score).toFixed(1)}</Typography>
        }
        else if (!props.IsGraded && props.SubmissionDate) {
            return <Typography variant="h6">{'Submitted: ' + moment(props.SubmissionDate).format('MM-DD-YYYY HH:mm:ss')}</Typography>
        }
    }

    handleBackDashboard = () => {
        const currentAssignment = this.props.currentAssignment
        if (currentAssignment.header.IsGradable === 0 && this.props.studentAssignment.header.IsGraded === 0) {
            this.props.submitNonGradedAssignment(this.props.studentAssignment, currentAssignment.header.TotalScore)
        }
        return this.props.history.push('/course-dashboard/' + this.props.studentAssignment.header.company_calendar_course_id + '/' + this.props.studentAssignment.header.CourseUnscheduled)
    }

    handleBack = () => {
        const prevEvent = this.props.prevEvent
        return this.props.history.push(`/${prevEvent.EventType}/student/${prevEvent.company_calendar_event_id}`)
    }

    getPageContent = (current_tab) => {
        const { currentAssignment, studentAssignment, auth } = this.props;  

        switch (current_tab) {  
            case (0): // Detail
                {   
                    return (
                        <Grid container spacing={24}>
                            <Grid item xs={12}>
                                <Typography variant="h5">{currentAssignment.header.AssignmentName}</Typography>
                                {this.getGradeInfo(this.props.studentAssignment.header)}
                                {this.props.currentAssignment.header.IsGradable === 1 ?
                                    <Typography variant="caption">{'This assignment requires a student submission'}</Typography>
                                    :
                                    null
                                }
                            </Grid>

                            <Grid item xs={12}>
                            <Typography variant="subtitle1">{currentAssignment.header.AssignmentDescription}</Typography>
                            <div style={{ padding: '10px' }} dangerouslySetInnerHTML={{__html: parseForFrontend(currentAssignment.header.AssignmentContent, currentAssignment.assetList)}}></div>
                                
                            </Grid>
                            {/* <Grid item xs={12}>
                                <RichTextEditor
                                    value={RichTextEditor.createValueFromString((currentAssignment.header.AssignmentContent || ''), 'html')}
                                    onChange={this.onEditorStateChange}
                                    readOnly={true}
                                />
                            </Grid> */}
                            <Grid item xs={12}>
                                <Typography variant="body1">Instructor Attachments</Typography>
                                <Divider />
                                {currentAssignment.assetList.map((asset) => {
                                    return (
                                        <li key={asset.header.asset_id}><a href={asset.header.URL} target="_blank">{asset.header.AssetNewName}</a> {asset.header.OriginalURL ? '  |  ' : null} {asset.header.OriginalURL ? <a href={asset.header.OriginalURL} target="_blank">download powerpoint</a> : null} </li>
                                    );
                                })}
                            </Grid>
                        </Grid>
                    );
                }
            case (1): // File Upload
                {
                    return (
                        <Grid container spacing={24}>
                            <Grid item xs={12}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>File Name</TableCell>
                                            <TableCell>Upload Date</TableCell>
                                            <TableCell>Delete</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {studentAssignment.assetList.map((asset) => {
                                            return (
                                                <TableRow key={asset.header.asset_id}>
                                                    <TableCell>{asset.header.AssetName}</TableCell>
                                                    <TableCell>{moment(asset.header.CreationDate).format("MM-DD-YYYY hh:mm:ss")}</TableCell>
                                                    <TableCell>
                                                        <IconButton
                                                            onClick={(ev) => {
                                                                ev.stopPropagation();
                                                                this.props.deleteAsset(
                                                                    asset.header.asset_id,
                                                                    'student_assignment',
                                                                    this.props.studentAssignment.header.student_assignment_id,
                                                                    this.props.deleteStudentAssignmentAsset
                                                                );
                                                            }}
                                                        >
                                                            <Icon>delete</Icon>
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </Grid>
                            <Grid item xs={12}>
                                <AssetUpload
                                    file_type={"Student Assignment"}
                                    auth_id={auth.user.data.auth_id}
                                    modelType={"student_assignment"}
                                    model_id={this.props.studentAssignment.header.student_assignment_id}
                                    requires_relation={true}
                                    getAssetList={this.props.addStudentAssignmentAsset}
                                />
                            </Grid>
                        </Grid>
                    );
                }
        }
    }

    getButtonContent = () => {

    }

    render() {
        const { classes, isAssignmentLoaded, auth, studentAssignment, currentAssignment } = this.props;
        const { current_tab } = this.state;
        const button_content = this.getButtonContent();
        let tabButtons
        if (auth.user.role === 'student') {

            tabButtons = (
                <TabPanelButtons
                    component_name = {"assignment"}
                    view_type      = {'detail'}
                    classes        = {classes}
                    button_list    = {[
                        
                        {
                            display:     "Back",
                            type:        "back",
                            onClick:     () => this.handleBack(),
                            // hidden:      this.hideContinue(),
                            disabled:    !this.props.prevEvent
                        },
                        {
                            display:     studentAssignment.header.NewUserAuthRole === 0 ? 'Course Dashboard' : 'Course Menu',
                            type:        "back",
                            onClick:     () => this.handleBackDashboard(),
                            hidden:      this.props.auth.user.role !== 'student',
                            largeLabel: true
                            // button_size: 'small',
                        },
                        {
                            display:     "Next",
                            type:        "back",
                            onClick:     this.handleContinue,
                            disabled:    this.continueDisabled(),
                            // hidden:      this.hideContinue(),
                            hidden:      this.props.auth.user.role !== 'student',
                        },
                        // {
                        //     display:     "Finish Course",
                        //     type:        "back",
                        //     onClick:     () => this.props.history.push('/dashboard'),
                        //     hidden:      this.hideFinishCourse(),
                        //     disabled:    !this.props.prevEvent,
                        //     button_size: 'small'
                        // },
                    ]}
                />
            )

        }
        else {
            tabButtons = (
                <TabPanelButtons
                    component_name = {"assignment"}
                    view_type      = {'detail'}
                    classes        = {classes}
                    button_list    = {[
                        {
                            display: "Back",
                            type:    "back",
                            onClick: () => this.props.history.goBack(),
                        }
                    ]}
                />
            )
        }

        let page_content = <React.Fragment>Loading...</React.Fragment>;
        if (isAssignmentLoaded) {
            page_content = this.getPageContent(current_tab);
        }
        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <div className="py-24"><h4>{'Student Assignment'}</h4></div>
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%' }}>
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Detail"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="File Upload"
                                    disabled={
                                        (this.props.studentAssignment.header.IsGraded === 1 || this.props.studentAssignment.header.SubmissionDate != null)
                                        &&
                                        this.props.studentAssignment.gradebook_detail.RetakeEvent !== 1
                                    }
                                    hidden={this.props.currentAssignment.header.IsGradable === 0}
                                />
                            </Tabs>
                            {tabButtons}
                        </Grid>
                    </div>
                }
                content={
                    <React.Fragment>
                        <div className="p-24">
                            {page_content}
                        </div>
                        <div className="p-24 float-right">
                            <Button
                                onClick={() => this.handleContinue()}
                                disabled={this.continueDisabled()}
                                variant={'contained'}
                            >
                                Next
                            </Button>
                        </div>
                    </React.Fragment>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAssignment:                      Actions.getAssignment,
        updateAssignmentLoaded:             Actions.updateAssignmentLoaded,
        getAssignmentData:                  Actions.getAssignmentData,
        getAssignmentByStudentAssignmentID: Actions.getAssignmentByStudentAssignmentID,
        getAssignmentByEventID:             Actions.getAssignmentByEventID,
        deleteStudentAssignmentAsset:       Actions.deleteStudentAssignmentAsset,
        addStudentAssignmentAsset:          Actions.addStudentAssignmentAsset,
        getModelAssetList:                  AssetActions.getModelAssetList,
        deleteAsset:                        AssetActions.deleteAsset,
        submitNonGradedAssignment:          Actions.submitNonGradedAssignment,
        getNextEventForContinueButton:      Actions.getNextEventForContinueButton
    }, dispatch);
}

function mapStateToProps({ assignmentApp, assetApp, auth }) {
    return {
        isAssignmentLoaded: assignmentApp.assignments.isAssignmentLoaded,
        currentAssignment:  assignmentApp.assignments.currentAssignment,
        studentAssignment:  assignmentApp.student_assignment.studentAssignment,
        nextEvent:          assignmentApp.student_assignment.nextEvent,
        prevEvent:          assignmentApp.student_assignment.prevEvent,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(StudentAssignment)));



// WEBPACK FOOTER //
// src/main/content/assignment/StudentAssignment.js